// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__jdfBn","catImage":"NotFound_catImage__cwvWc","title":"NotFound_title__9l1nr","text":"NotFound_text__uwa+s","btn":"NotFound_btn__B3QZO"};